<!-- Marketplace feed (desktop) -->
<a class="fmp mpd" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
  <div class="mpd-media">
    <img class="fmp-logo mpd-logo" [src]="avatar" alt="" />
    <app-meta-creative class="fmp-image mpd-image" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
  </div>
  <div class="fmp-ellipsis mpd-name">{{ pageName }}</div>
  <div class="fmp-clamp mpd-headline">{{ headline }}</div>
  <div class="fmp-muted mpd-label">Plaćeni oglas</div>
</a>
